var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "md-layout" }, [
    _c(
      "div",
      {
        staticClass:
          "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100",
      },
      [
        _c("div", { staticClass: "custom-toolbar" }, [
          _c(
            "div",
            { staticClass: "custom-toolbar-start" },
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: "Team Settings",
                    },
                  },
                },
                [_c("h3", { staticClass: "title" }, [_vm._v("Team Settings")])]
              ),
              _c("h3", { staticClass: "title" }, [
                _vm._v("   >    " + _vm._s(_vm.$t("menus.setting.items"))),
              ]),
            ],
            1
          ),
        ]),
      ]
    ),
    _c(
      "div",
      { staticClass: "md-layout-item md-size-100" },
      [
        _c(
          "md-card",
          [
            _c(
              "md-card-header",
              { staticClass: "md-card-header-icon md-card-header-blue" },
              [
                _c(
                  "div",
                  { staticClass: "card-icon" },
                  [_c("md-icon", [_vm._v("inventory")])],
                  1
                ),
              ]
            ),
            _c("md-card-content", [
              _c("h5", { staticClass: "card-title" }, [
                _vm._v("\n                    Settings\n                "),
              ]),
              _c("div", { staticClass: "md-layout" }, [
                _c(
                  "div",
                  { staticClass: "md-layout-item md-size-100 layout-item" },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "md-checkbox",
                          {
                            model: {
                              value: _vm.includeItemsInEmailsAndPODDocuments,
                              callback: function ($$v) {
                                _vm.includeItemsInEmailsAndPODDocuments = $$v
                              },
                              expression: "includeItemsInEmailsAndPODDocuments",
                            },
                          },
                          [
                            _vm._v(
                              "\n                                Include items in stop status change emails and POD/failed PDF documents\n                            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "md-layout-item md-size-100 layout-item" },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "md-checkbox",
                          {
                            model: {
                              value: _vm.totalItemLoadAsStopLoad,
                              callback: function ($$v) {
                                _vm.totalItemLoadAsStopLoad = $$v
                              },
                              expression: "totalItemLoadAsStopLoad",
                            },
                          },
                          [
                            _vm._v(
                              "\n                                Stop load quantities total of items\n                            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]),
            _c("md-card-actions", { attrs: { "md-alignment": "left" } }, [
              _c(
                "button",
                {
                  staticClass: "custom-btn",
                  on: { click: _vm.saveItemSettings },
                },
                [_vm._v("\n                    Save\n                ")]
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }